// extracted by mini-css-extract-plugin
export default {"heading":"Ks-z","signin":"Ls-z","signupBtn":"Ms-z","disabled":"Ns-z"};